export const setCURRENTACCOUNTOBJECT = "setCURRENTACCOUNTOBJECT";
